import { Provider } from '@angular/core';
import { CB_CORE_ENV, CbCoreEnvironment } from '@cbcore/environment/cb-core-env.token';
import { CB_UI_ENV, CbUiEnvironment } from '@cbui/environment/cb-ui-env.token';
import { GEOLOCATION_SERVICE_TOKEN } from '@cbcore/index';
import { environment } from '@environment/environment';

export function provideEnvironmentTokens(): Provider[] {
  return [
    {
      provide: GEOLOCATION_SERVICE_TOKEN,
      useValue: null
    },
    {
      provide: CB_UI_ENV,
      useValue: {
        haveCommunicationHander: environment.haveCommunicationHander,
        web: environment.web,
        isCB: environment.isCB
      } satisfies CbUiEnvironment
    },
    {
      provide: CB_CORE_ENV,
      useValue: {
        production: environment.production,
        sentryUrl: environment.sentryUrl,
        sentryShowDialog: environment.sentryShowDialog,
        includeLegs: environment.includeLegs,
        allEndpointsWithCredentials: environment.allEndpointsWithCredentials
      } satisfies CbCoreEnvironment
    }
  ];
}
